var map = {
	"./fridge-temperature-log-book_B09JRLJY3C.jpg": "1277",
	"./inventory-log-book_B09PVW2VW3.jpg": "6122",
	"./notary-journal_B09JR9TH5T.jpg": "bfa2",
	"./timesheet-log-book_B09NH3CTNT.jpg": "9f23",
	"./vehicle-maintenance-log-book_B09KNGG2DZ.jpg": "bd3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a5c";